import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const PAGE_TITLE = 'TEATRO PRONTO™ – Il tuo anno di teatro a scuola, 100% già pronto';
const PAGE_DESCRIPTION = 'Il sistema 6-in-1 per il teatro a scuola (Primaria e Secondaria): 8 copioni originali (3 di Natale), piano prove di 6 settimane, 120 giochi teatrali, 12 lezioni minuto per minuto e rubriche di valutazione, più 5 bonus. PDF, pagamento unico, garanzia 7 giorni.';
function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'it';
    document.title = PAGE_TITLE;
    setMeta('name', 'description', PAGE_DESCRIPTION);
    setMeta('property', 'og:title', PAGE_TITLE);
    setMeta('property', 'og:description', PAGE_DESCRIPTION);
    setMeta('property', 'og:locale', 'it_IT');
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="35ox2qy1z4t4">
      <div lang="it" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="34ncnvv5d5yq">
        <CountdownBar data-id="element-2" data-mp="3uc9nq9k74apm" />
        <main data-id="element-3" data-mp="3uf5hrmsxaf8s">
          <Hero data-id="element-4" data-mp="d4e5zu7z1ex8" />
          <InsidePages data-id="element-5" data-mp="d57d4waue6fw" />
          <StatsBar data-id="element-6" data-mp="d3cw3t2oyyh3" />
          <Difference data-id="element-7" data-mp="d3wa4yp812pu" />
          <Recognize data-id="element-8" data-mp="85l30vqb96bb" />
          <WhatsInside data-id="element-9" data-mp="851n1kk80rzx" />
          <Bonuses data-id="element-10" data-mp="86w76wno4g2y" />
          <HowItWorks data-id="element-11" data-mp="86clr5yt79k6" />
          <Audience data-id="element-12" data-mp="3gle7udba4tcj" />
          <Offer data-id="element-13" data-mp="3gkv01pfcflc8" />
          <Guarantee data-id="element-14" data-mp="3gmfwjkl7xecq" />
          <Testimonials data-id="element-15" data-mp="3glwabrojc3sw" />
          <Faq data-id="element-16" data-mp="3gj1r23h9cp12" />
          <FinalCta data-id="element-17" data-mp="3bmjqlfsyncuj" />
        </main>
        <Footer data-id="element-18" data-mp="3bnct24kvzg6v" />
      </div>
    </MotionConfig>;
}